import PlanRow from "./PlanRow";
import { useState, useEffect } from "react";
import apiClient from "../api/apiClient";
import { useLanguage } from "../i18n/LanguageContext";
import { usePackageCheckout } from "../hooks/usePackageCheckout";

export const DynamicLibraryModal = ({
  pkg,
  selectedIds,
  onToggle,
  onClose,
  onConfirm,
  loading,
  error,
}) => {
  const { t } = useLanguage();
  if (!pkg) return null;

  const required = Number(pkg.library_selection_count || 0);
  const complete = selectedIds.length === required;

  return (
    <div className="hpa-dynamic-package-backdrop" role="dialog" aria-modal="true" aria-labelledby="dynamic-package-title">
      <div className="hpa-dynamic-package-dialog">
        <button type="button" className="hpa-dynamic-package-close" onClick={onClose} aria-label={t("Close")}>
          &times;
        </button>
        <span className="hpa-dynamic-package-kicker">{t("Build your access")}</span>
        <h3 id="dynamic-package-title">{pkg.name}</h3>
        <p>
          {t("Choose exactly {count} libraries. Your subscription will unlock only your selected libraries.", { count: required })}
        </p>

        <div className="hpa-dynamic-library-grid">
          {(pkg.libraries || []).map((library) => {
            const selected = selectedIds.includes(library.id);
            const disabled = !selected && selectedIds.length >= required;

            return (
              <button
                type="button"
                key={library.id}
                className={`hpa-dynamic-library-option ${selected ? "selected" : ""}`}
                onClick={() => onToggle(library.id)}
                disabled={disabled}
              >
                <span className="hpa-dynamic-library-check">
                  <i className={`fa-solid ${selected ? "fa-check" : "fa-plus"}`} />
                </span>
                <strong>{library.name}</strong>
              </button>
            );
          })}
        </div>

        <div className="hpa-dynamic-selection-count">
          {t("{selected} of {required} selected", { selected: selectedIds.length, required })}
        </div>
        {error && <div className="hpa-dynamic-package-error">{error}</div>}

        <button
          type="button"
          className="btn btn-primary btn-skew hpa-dynamic-package-confirm"
          onClick={onConfirm}
          disabled={!complete || loading}
        >
          <span>{loading ? t("Preparing payment…") : t("Continue to Payment")}</span>
        </button>
      </div>
    </div>
  );
};


const PricingTable = ({ showBackground = false, backgroundImage = null }) => {
  const { t, language } = useLanguage();
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const { startCheckout, dynamicPickerProps } = usePackageCheckout();

  useEffect(() => {
    apiClient.get("/packages")
      .then((res) => setPackages(res.data.data || []))
      .catch(() => setPackages([]))
      .finally(() => setLoading(false));
  }, [language]);

  if (loading) {
    return (
      <section className="content-inner rounded-shape-top overflow-hidden bg-white">
        <div className="container text-center py-5">
          <p>{t("Loading plans…")}</p>
        </div>
      </section>
    );
  }

  if (!packages.length) return null;

  return (
    <section
      className={`content-inner rounded-shape-top overflow-hidden hpa-pricing-section ${showBackground ? "" : "bg-white"}`}
      style={showBackground && backgroundImage ? { backgroundImage: `url(${backgroundImage})` } : undefined}
    >
      <div className="container">

        <div className="hpa-plan-list">
          {packages.map((pkg) => (
            <PlanRow
              key={pkg.id}
              pkg={pkg}


              onGetAccess={() => startCheckout(pkg)}
            />
          ))}
        </div>

      </div>
      <DynamicLibraryModal {...dynamicPickerProps} />
    </section>
  );
};

export default PricingTable;
